import { render, staticRenderFns } from "./ControlIrrigation.vue?vue&type=template&id=40421868&scoped=true&"
import script from "./ControlIrrigation.vue?vue&type=script&lang=js&"
export * from "./ControlIrrigation.vue?vue&type=script&lang=js&"
import style0 from "./ControlIrrigation.vue?vue&type=style&index=0&id=40421868&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40421868",
  null
  
)

export default component.exports